(() => {
  if (customElements.get('cards-carousel')) {
    return;
  }

  class CardsCarousel extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const sliderList = this.querySelector('.splide');

      if (!sliderList) return;

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      this.slider = new Splide(this.querySelector('.splide'), {
        trimSpace: 'move',
        waitForTransition: false,
        flickMaxPages: 0.5,
        fixedWidth: '41.2rem',
        gap: '4.5rem',
        pagination: false,
        arrows: false,
        breakpoints: {
          990: {
            type: 'slide',
            fixedWidth: '74%',
            gap: '2rem'
          }
        }
      }).mount();
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }
  }

  customElements.define('cards-carousel', CardsCarousel);
})();
